var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.82422C16 10.9459 15.1571 12.9808 13.6569 14.4811C12.1566 15.9813 10.1217 16.8242 8 16.8242C5.87827 16.8242 3.84344 15.9813 2.34315 14.4811C0.842855 12.9808 0 10.9459 0 8.82422C0 6.70249 0.842855 4.66766 2.34315 3.16737C3.84344 1.66707 5.87827 0.824219 8 0.824219C10.1217 0.824219 12.1566 1.66707 13.6569 3.16737C15.1571 4.66766 16 6.70249 16 8.82422Z",
    fill: "url(#paint0_linear_2_1661)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2002 14.3752C5.2002 14.9032 6.4532 14.8192 8.0002 14.8192C9.5462 14.8192 10.8002 14.9032 10.8002 14.3752C10.8002 13.7392 9.5462 13.3242 8.0002 13.3242C6.4532 13.3242 5.2002 13.7392 5.2002 14.3752Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.2002 14.3752C5.2002 14.9032 6.4532 14.8192 8.0002 14.8192C9.5462 14.8192 10.8002 14.9032 10.8002 14.3752C10.8002 13.7392 9.5462 13.3242 8.0002 13.3242C6.4532 13.3242 5.2002 13.7392 5.2002 14.3752Z",
    fill: "url(#paint1_linear_2_1661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59968 10.6556C3.59968 9.86461 4.13769 9.22461 4.79969 9.22461C5.46269 9.22461 5.99969 9.86461 5.99969 10.6556C5.99969 10.9846 5.90669 11.2886 5.74769 11.5296C5.67339 11.6406 5.55973 11.7192 5.42968 11.7496C5.27968 11.7856 5.05669 11.8246 4.79969 11.8246C4.54269 11.8246 4.31869 11.7856 4.16969 11.7496C4.03951 11.7195 3.92576 11.6408 3.85168 11.5296C3.68426 11.2691 3.59667 10.9653 3.59968 10.6556ZM9.99968 10.6556C9.99968 9.86461 10.5367 9.22461 11.1997 9.22461C11.8617 9.22461 12.3997 9.86461 12.3997 10.6556C12.3997 10.9846 12.3057 11.2886 12.1477 11.5296C12.0736 11.6408 11.9599 11.7195 11.8297 11.7496C11.6233 11.799 11.4119 11.8241 11.1997 11.8246C10.9427 11.8246 10.7197 11.7856 10.5697 11.7496C10.4394 11.7192 10.3254 11.6406 10.2507 11.5296C10.084 11.2688 9.99683 10.9651 9.99968 10.6556Z",
    fill: "url(#paint2_linear_2_1661)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59968 10.6556C3.59968 9.86461 4.13769 9.22461 4.79969 9.22461C5.46269 9.22461 5.99969 9.86461 5.99969 10.6556C5.99969 10.9846 5.90669 11.2886 5.74769 11.5296C5.67339 11.6406 5.55973 11.7192 5.42968 11.7496C5.27968 11.7856 5.05669 11.8246 4.79969 11.8246C4.54269 11.8246 4.31869 11.7856 4.16969 11.7496C4.03951 11.7195 3.92576 11.6408 3.85168 11.5296C3.68426 11.2691 3.59667 10.9653 3.59968 10.6556ZM9.99968 10.6556C9.99968 9.86461 10.5367 9.22461 11.1997 9.22461C11.8617 9.22461 12.3997 9.86461 12.3997 10.6556C12.3997 10.9846 12.3057 11.2886 12.1477 11.5296C12.0736 11.6408 11.9599 11.7195 11.8297 11.7496C11.6233 11.799 11.4119 11.8241 11.1997 11.8246C10.9427 11.8246 10.7197 11.7856 10.5697 11.7496C10.4394 11.7192 10.3254 11.6406 10.2507 11.5296C10.084 11.2688 9.99683 10.9651 9.99968 10.6556Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.96848 10.1568C4.97338 10.1802 4.97572 10.204 4.97548 10.2278C4.97548 10.4288 4.79948 10.5938 4.58148 10.5938C4.36448 10.5938 4.18848 10.4288 4.18848 10.2278C4.18848 10.1448 4.21848 10.0678 4.26848 10.0068C4.49248 10.0598 4.72748 10.1108 4.96848 10.1568ZM10.8945 10.5938C10.6835 10.5938 10.5115 10.4408 10.5015 10.2458C10.7605 10.2078 11.0175 10.1608 11.2675 10.1098C11.2813 10.148 11.2881 10.1883 11.2875 10.2288C11.2875 10.4288 11.1125 10.5938 10.8945 10.5938Z",
    fill: "#4F4F67"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99959 8.42422C8.99959 7.97822 9.16259 7.82422 9.44459 7.82422C9.72459 7.82422 9.85859 8.10022 9.95059 8.89022C11.0786 8.89022 12.9886 8.35622 13.1726 8.35622C13.3506 8.35622 13.4496 8.44122 13.4896 8.62322C13.5246 8.78122 13.4666 8.93122 13.2686 9.02322C12.6476 9.31022 10.8256 9.95822 9.28459 9.95822C9.11659 9.95822 8.99959 9.87222 8.99959 9.65722V8.42422ZM6.04859 8.89022C6.14059 8.10022 6.27459 7.82422 6.55459 7.82422C6.83659 7.82422 6.99959 7.97822 6.99959 8.42422V9.65722C6.99959 9.87222 6.88259 9.95822 6.71459 9.95822C5.17359 9.95822 3.35159 9.31022 2.73059 9.02322C2.53259 8.93122 2.47459 8.78122 2.50959 8.62322C2.55059 8.44122 2.64959 8.35622 2.82659 8.35622C3.01059 8.35622 4.92059 8.89022 6.04859 8.89022Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.99959 8.42422C8.99959 7.97822 9.16259 7.82422 9.44459 7.82422C9.72459 7.82422 9.85859 8.10022 9.95059 8.89022C11.0786 8.89022 12.9886 8.35622 13.1726 8.35622C13.3506 8.35622 13.4496 8.44122 13.4896 8.62322C13.5246 8.78122 13.4666 8.93122 13.2686 9.02322C12.6476 9.31022 10.8256 9.95822 9.28459 9.95822C9.11659 9.95822 8.99959 9.87222 8.99959 9.65722V8.42422ZM6.04859 8.89022C6.14059 8.10022 6.27459 7.82422 6.55459 7.82422C6.83659 7.82422 6.99959 7.97822 6.99959 8.42422V9.65722C6.99959 9.87222 6.88259 9.95822 6.71459 9.95822C5.17359 9.95822 3.35159 9.31022 2.73059 9.02322C2.53259 8.93122 2.47459 8.78122 2.50959 8.62322C2.55059 8.44122 2.64959 8.35622 2.82659 8.35622C3.01059 8.35622 4.92059 8.89022 6.04859 8.89022Z",
    fill: "url(#paint3_linear_2_1661)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_1661",
    x: 4.2002,
    y: 13.3242,
    width: 7.59998,
    height: 3.49989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.509681 0 0 0 0 0 0 0 0 0.371207 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_1661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_1661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2_1661",
    x: 3.59961,
    y: 9.22461,
    width: 8.80011,
    height: 2.60001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0387428 0 0 0 0 0.0406183 0 0 0 0 0.0875053 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_1661"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2_1661",
    x: 2.4,
    y: 7.82422,
    width: 11.1992,
    height: 2.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.565875 0 0 0 0 0.151272 0 0 0 0 0 0 0 0 0.15024 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_1661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_1661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1661",
    x1: 8,
    y1: 0.824219,
    x2: 8,
    y2: 11.5752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1661",
    x1: 8,
    y1: 13.5272,
    x2: 8,
    y2: 14.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661C04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1661",
    x1: 8,
    y1: 9.22422,
    x2: 8,
    y2: 11.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#3B426A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1661",
    x1: 11.615,
    y1: 10.1572,
    x2: 11.615,
    y2: 7.82422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A2F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D44800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.824219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.8c687f804357feccee7bc8d0fbb9c8c3.svg";
export { ForwardRef as ReactComponent };